export { default } from './NewsletterModal';

